import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {reportMetadataZodValidator, type ReportMetadata} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/Report";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export enum ReportCollectionStatus {
    active = "bb79b663-545e-411f-a1e4-0147477ecc8a",
    deleted = "f8c661c9-9dac-4436-a05d-b22db6565973",
}

export type ReportCollection = {
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    description: string;
    displayName: string;
    id: Uuid;
    reportIds: Array<Uuid>;
    status: ReportCollectionStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export type ReportCollectionWithReportsMetadata = ReportCollection & {
    reports: Array<ReportMetadata>;
};

export const reportCollectionZodValidator: zod.ZodType<ReportCollection> = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    description: zod.string(),
    displayName: zod.string(),
    id: uuidZodValidator,
    reportIds: zod.array(uuidZodValidator),
    status: zod.enum(ReportCollectionStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});

export const reportCollectionWithReportsMetadataZodValidator: zod.ZodType<ReportCollectionWithReportsMetadata> = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    description: zod.string(),
    displayName: zod.string(),
    id: uuidZodValidator,
    reportIds: zod.array(uuidZodValidator),
    reports: zod.array(reportMetadataZodValidator),
    status: zod.enum(ReportCollectionStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
